// extracted by mini-css-extract-plugin
export default {"p_tye":"_2360486c5e","slcted":"_623cf3ce68","slc_color":"a7bc014df5","item_p":"_94214a3314","r0":"e43e0dc37b"};